{
  "bookmarkTitleLabel": "Lesezeichen",
  "debug": "Debugging",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Ergebnisse aus Experience League",
  "feedback": "Feedback",
  "fetchFailed": "Abruf fehlgeschlagen",
  "help": "Hilfe",
  "helpDefaultFeatured": "Lernmaterialien und Support für Adobe Experience Cloud",
  "helpLoadError": "Ein Fehler ist aufgetreten. Versuchen Sie es erneut.",
  "noBookmarks": "Kennzeichnen Sie die Hilfeinhalte mit einem Lesezeichen, um über diese Seite darauf zuzugreifen.",
  "noBookmarksTitle": "Keine Lesezeichen",
  "noResults": "Keine Ergebnisse gefunden",
  "noResultsMessage": "Überprüfen Sie die Schreibweise oder versuchen Sie es mit einem anderen Suchbegriff.",
  "resourcesCustomerCareLabel": "Kundenunterstützung",
  "resourcesStatusLabel": "Status",
  "support": "Support"
}
